import { BehaviorSubject } from "rxjs";

import { State } from "..";

import type { ReactNode } from "react";

export type AppOverlayPanelStateType = {
  shown: boolean;
  onClose?: () => void;
  children?: ReactNode;
  size?: number;
};
export type AppNotificationType = {
  code: number;
  message: ReactNode | string;
  shown?: boolean;
  duration?: number;
};
export type NotifierType = {
  bufferSize: number;
  $notifications: BehaviorSubject<AppNotificationType | null>;
};

export type AppStateType = {
  dialog?: AppOverlayPanelStateType;
  rightDrawer?: AppOverlayPanelStateType;
  leftDrawer?: AppOverlayPanelStateType;
  isLoading?: boolean;
  $notifier?: NotifierType;
};

export class AppState extends State<AppStateType> {
  constructor(notificationBufferSize = 3) {
    super({
      dialog: {
        shown: false,
      },
      leftDrawer: {
        shown: false,
      },
      rightDrawer: {
        shown: false,
      },
      isLoading: false,
      $notifier: {
        bufferSize: notificationBufferSize >= 3 ? 3 : 1,
        $notifications: new BehaviorSubject<AppNotificationType | null>(null),
      },
    });
  }
  dialog(method: "open" | "close", children?: ReactNode, onClose?: () => void) {
    const prev = this._observable.getValue() || {};
    this._observable.next({
      ...prev,
      dialog: { shown: method === "open", onClose, children },
    });
  }
  rightDrawer(
    method: "open" | "close",
    size?: number,
    children?: ReactNode,
    onClose?: () => void,
  ) {
    const prev = this._observable.getValue() || {};
    this._observable.next({
      ...prev,
      rightDrawer: { shown: method === "open", onClose, size, children },
    });
  }
  leftDrawer(
    method: "open" | "close",
    size?: number,
    children?: ReactNode,
    onClose?: () => void,
  ) {
    const prev = this._observable.getValue() || {};
    this._observable.next({
      ...prev,
      leftDrawer: { shown: method === "open", onClose, size, children },
    });
  }
  isLoading(isLoading: boolean) {
    const prev = this._observable.getValue() || {};
    this._observable.next({
      ...prev,
      isLoading,
    });
  }
  addNotification(notification: AppNotificationType) {
    this._observable.getValue()?.$notifier?.$notifications.next(notification);
  }
  clear(): void {
    this._observable.next(null);
  }
}
